export * from '@kaidam/fc-shared/src/frontend/store/selectors/network'
import defaultSelectors from '@kaidam/fc-shared/src/frontend/store/selectors/network'
export default defaultSelectors